export const activeMemberships = {
  "en-GB": {
    plusMembershipId: "3074457345616767232",
    plusMembershipWithStarterKitId: "3074457345616777230",
    staffMembershipId: "3074457345616769230",
    monthlyMembershipId: "3074457345616767234",
    monthlyMembership300Id: "3074457345616728317",
    giftMembershipId: "3074457345616768736",
    partnerGiftMembershipId: "3074457345616752730",
    freeTrialMembershipId: "3074457345616780730",
    freeTrialMembership30Id: "3074457345616770240",
    annualLimitlessMembershipId: "3074457345616802730",
    freeTrialLimitlessMembership30Id: "",
    monthlyLimitlessMembershipId: "3074457345616804240",
    threeMonthFreeTrialMembershipId: "3074457345616809730",
    threeMonthPaidRenewsAnnuallyId: "3074457345616815432",
    thirtyDayFreeTrialMembershipId: "3074457345616815743",
    thirtyDayFreeTrialRenewsToMonthlyMembershipId: "3074457345616815282",
    sixtyDayFreeTrialRenewsToMonthlyMembershipId: "3074457345616815322",
    sixtyDayFreeTrialRenewsToAnnualMembershipId: "3074457345617583401",
    annualLiteMembership: "3074457345614994501"
  },
  "en-US": {
    plusMembershipId: "3074457345616760237",
    plusMembershipWithStarterKitId: "3074457345616777232",
    staffMembershipId: "3074457345616769232",
    monthlyMembershipId: "3074457345616761749",
    monthlyMembership300Id: "3074457345616728352",
    giftMembershipId: "3074457345616760247",
    partnerGiftMembershipId: "3074457345616755231",
    freeTrialMembershipId: "3074457345616780732",
    freeTrialMembership30Id: "3074457345616770230",
    annualLimitlessMembershipId: "3074457345616795237",
    freeTrialLimitlessMembership30Id: "3074457345616796264",
    monthlyLimitlessMembershipId: "3074457345616795239",
    threeMonthFreeTrialMembershipId: "3074457345616810729",
    threeMonthPaidRenewsAnnuallyId: "3074457345616815434",
    thirtyDayFreeTrialMembershipId: "3074457345616815745",
    thirtyDayFreeTrialRenewsToMonthlyMembershipId: "3074457345616815284",
    sixtyDayFreeTrialRenewsToMonthlyMembershipId: "3074457345616815324",
    sixtyDayFreeTrialRenewsToAnnualMembershipId: "3074457345617583302",
    annualLiteMembership: "3074457345614994502"
  }
} as const;
